<template>
  <basic-container id="carcoupon20220323">
    <avue-crud
      :option="option"
      :search.sync="searchForm"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="parkingLotIdSearch" slot-scope="scope">
        <selectSearch  v-model="query.parkingLotId" :dicData="parkingLotList"></selectSearch>
        <!-- <el-select
          v-model="query.parkingLotId"
          placeholder="车场名称:"
          style="width: 100%"

        >
          <el-option
            v-for="item in parkingLotList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="carCouponDialogOpen"
          v-if="permission.carcoupon_add"
          >新 增
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="新增"
      :visible.sync="carCouponAddShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="carCouponDialogClose"
      width="40%"
    >
      <div class="el-dialog-div">
        <el-form ref="addForm" :rules="rules" :model="addForm" label-width="120px">
          <el-form-item label="车场名称" prop="parkingLotId">
            <selectSearch  v-model="addForm.parkingLotId" :dicData="parkingLotList"></selectSearch>
            <!-- <el-select
              v-model="addForm.parkingLotId"
              placeholder="请选择车场"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in parkingLotList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="优惠券名称" prop="couponName">
            <el-input v-model="addForm.couponName" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="优惠券类型" prop="couponType">
            <el-select
              v-model="addForm.couponType"
              placeholder="请选择优惠券类型"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in couponTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠额度" prop="couponLimit">
            <el-input
              :disabled="couponLimitDisable"
              v-model.number="addForm.couponLimit"
              maxlength="10"
            >
              <template slot="append" v-if="addForm.couponType == 1">小时</template>
              <template slot="append" v-if="addForm.couponType == 2">元</template>
              <template slot="append" v-if="addForm.couponType == 3">次</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="couponLimitDisable" label="最大时长" prop="couponMaxTime">
            <el-input v-model.number="addForm.couponMaxTime" maxlength="10">
              <template slot="append">小时</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单次使用" prop="couponUseLimit">
            <el-select
              v-model="addForm.couponUseLimit"
              placeholder="请选择单次使用"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in couponUseLimitList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-col style="text-align: right" span="24">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="carCouponAddSubmit"
                >保存</el-button
              >
              <el-button
                type="default"
                size="small"
                icon="el-icon-delete"
                @click="carCouponDialogClose"
                >返回</el-button
              >
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getDictionary } from '@/api/common';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/park/couponv2/coupon/carcoupon';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      query: {
        parkingLotId: '',
      },
      parkingLotList: [],
      couponTypeList: [],
      couponUseLimitList: [],
      carCouponAddShow: false,
      couponLimitDisable: false,
      addForm: {
        parkingLotId: '',
        couponName: '',
        couponType: '',
        couponLimit: '',
        couponMaxTime: 24,
        couponUseLimit: '',
      },
      rules: {
        parkingLotId: [{ required: true, message: '请选择车场', trigger: 'blur' }],
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { max: 50, message: '优惠券名称最大长度为50字符', trigger: 'blur' },
        ],
        couponType: [{ required: true, message: '请选择优惠券类型', trigger: 'blur' }],
        couponLimit: [
          { required: true, message: '请输入优惠额度', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        couponMaxTime: [
          { required: true, message: '请输入优惠最大时长', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        couponUseLimit: [{ required: true, message: '请选择单次使用', trigger: 'blur' }],
      },
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        align: 'left',
        height: 'auto',
        calcHeight: 55,
        tip: false,
        searchShow: true,
        searchMenuSpan: 18,
        border: true,
        index: true,
        indexLabel: '#',
        viewBtn: true,
        searchBtn: true,
        emptyBtn: true,
        selection: false,
        dialogClickModal: false,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            search: false,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            showColumn: false,
            hide: true,
            span: 12,
            search: true,
            searchslot: true,
            searchSpan: 6,
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '优惠券名称',
            prop: 'couponName',
            rules: [
              {
                required: true,
                message: '请输入优惠券名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠券类型',
            prop: 'couponType',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_coupon_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入优惠券类型(字典car_coupon_type)：1-时长券，2-现金券，3-次数券',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠额度',
            prop: 'couponLimit',
            rules: [
              {
                required: true,
                message:
                  '请输入优惠额度：单位根据优惠券类型进行动态显示：小时/元/次；如果是次数券时，默认就一次，不能添加>1的次券',
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: '最大时长',
          //   prop: 'couponMaxTime',
          //   rules: [{
          //     required: true,
          //     message: '请输入优惠最大时长',
          //     trigger: 'change',
          //   }],
          // },
          {
            label: '优惠券单次使用数量',
            prop: 'couponUseLimit',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=coupon_use_limit',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入优惠券单次使用数量：1-3',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
      searchForm: {},
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(null, false),
        viewBtn: this.vaildData(this.permission.carcoupon_view, false),
        delBtn: this.vaildData(this.permission.carcoupon_delete, false),
        editBtn: this.vaildData(this.permission.carcoupon_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.parkingLotList = data.data;
      if (this.parkingLotList.length > 0) {
        this.query.parkingLotId = this.parkingLotList[0].id;
      }
      this.onLoad();
    });
  },
  watch: {
    'addForm.couponType': function (val, oldVal) {
      //当优惠券类型为次数券时候，优惠额度默认是1,不能修改
      this.addForm.couponMaxTime = 24;
      if (val == 3) {
        this.addForm.couponLimit = 1;
        this.couponLimitDisable = true;
      } else {
        this.couponLimitDisable = false;
        this.addForm.couponLimit = '';
      }
    },
  },
  methods: {
    parkingLotIdChange(value) {
      this.query.parkingLotId = value;
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ('add' === type) {
        this.cleanForm();
      }
      done();
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      if (this.parkingLotList.length > 0) {
        this.query.parkingLotId = this.parkingLotList[0].id;
      }
      this.onLoad();
    },
    search() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    searchChange(params, done) {
      console.log('this.query', this.query);
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      this.loading = false;
      if (this.query.parkingLotId == '') {
        return;
      }
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          data.records.forEach((e) => {
            if (e.couponMaxTime == -1) {
              e.couponMaxTime = '';
            }
          });
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    carCouponDialogOpen() {
      this.carCouponAddShow = true;
      //设置默认车场
      if (this.parkingLotList.length > 0) {
        this.addForm.parkingLotId = this.query.parkingLotId;
      }
      //获取优惠券类型
      getDictionary('car_coupon_type').then((data) => {
        if (data.data.length > 0) {
          this.couponTypeList = data.data;
          this.addForm.couponType = this.couponTypeList[0].dictKey;
        }
      });
      getDictionary('coupon_use_limit').then((data) => {
        if (data.data.length > 0) {
          this.couponUseLimitList = data.data;
          this.addForm.couponUseLimit = this.couponUseLimitList[0].dictKey;
        }
      });
    },
    carCouponAddSubmit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          window.console.log(this.addForm);
          add(this.addForm).then(
            () => {
              console.log('submit!');
              this.carCouponDialogClose();
              this.$message.success('操作成功!');
              done();
            },
            (error) => {
              window.console.log(error);
            }
          );
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    carCouponDialogClose() {
      this.onLoad();
      this.$refs['addForm'].resetFields();
      this.carCouponAddShow = false;
      (this.addForm.parkingLotId = ''),
        (this.addForm.couponName = ''),
        (this.addForm.couponType = ''),
        (this.addForm.couponLimit = ''),
        (this.addForm.couponMaxTime = 24),
        (this.addForm.couponUseLimit = '');
    },
  },
};
</script>

<style lang="scss">
#carcoupon20220323 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search.el-form-item--small.el-form-item {
    width: 100%;
  }
  .avue-crud__search .el-form-item--mini.el-form-item,
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
